import { render, staticRenderFns } from "./RamNativeHeapChart.vue?vue&type=template&id=59b10d5e&scoped=true&"
import script from "./RamNativeHeapChart.vue?vue&type=script&lang=js&"
export * from "./RamNativeHeapChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b10d5e",
  null
  
)

export default component.exports